import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Megaphone, Search, FileText, Palette, Smartphone, Code2, Sparkles } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

// Phase 4: 6 services route to dedicated landing pages.
const SERVICES = [
  { slug: "meta-ads",        k: "services.cards.meta_ads",   icon: Megaphone, badge: null,             route: "landing" },
  { slug: "google-ads",      k: "services.cards.google_ads", icon: Search,    badge: null,             route: "landing" },
  { slug: "seo",             k: "services.cards.seo",        icon: FileText,  badge: null,             route: "landing" },
  { slug: "creative",        k: "services.cards.creative",   icon: Palette,   badge: "@postunhazir",   route: "landing" },
  { slug: "social-media",    k: "services.cards.social",     icon: Smartphone, badge: null,            route: "landing" },
  { slug: "web-development", k: "services.cards.web",        icon: Code2,     badge: null,             route: "landing" },
];

export default function ServicesGrid() {
  const { t, lang } = useLanguage();

  const buildLink = (s) =>
    s.route === "landing"
      ? `/${lang}/services/${s.slug}`
      : `/${lang}/contact?service=${s.slug}`;

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-cream py-section sm:py-section-lg"
    >
      <div className="container-page">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
          <Reveal as="div" className="lg:col-span-5">
            <span className="eyebrow">
              <Sparkles className="h-3 w-3 text-gold" />
              {t("services.eyebrow")}
            </span>
            <h2 className="mt-5 font-display text-display-2 font-semibold text-ink">
              {t("services.title_pre")}{" "}
              <span className="gold-foil-text">{t("services.title_accent")}</span>{" "}
              {t("services.title_post")}
            </h2>
            <p className="mt-5 max-w-md text-body-lg text-ink/65 leading-relaxed">
              {t("services.subtitle")}
            </p>
            <div className="hairline-gold mt-8" />
          </Reveal>

          <div className="lg:col-span-7 grid gap-5 sm:grid-cols-2">
            {SERVICES.map((s, i) => {
              const Icon = s.icon;
              const href = buildLink(s);
              return (
                <Reveal as="div" key={s.slug} delay={0.05 * i}>
                  <Link
                    to={href}
                    className="service-card block"
                    data-testid={`service-card-${s.slug}`}
                  >
                    <div className="flex items-start justify-between gap-4 relative">
                      <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-cream text-gold ring-1 ring-gold/30">
                        <Icon className="h-5 w-5" strokeWidth={1.5} />
                      </div>
                      {s.badge ? (
                        <span className="text-[0.65rem] uppercase tracking-[0.18em] text-gold border border-gold/40 rounded-full px-2.5 py-1">
                          {s.badge}
                        </span>
                      ) : (
                        <ArrowUpRight className="h-5 w-5 text-ink/30 transition-colors" />
                      )}
                    </div>
                    <h3 className="mt-7 font-display text-h2 font-semibold text-ink">
                      {t(`${s.k}.title`)}
                    </h3>
                    <p className="mt-2.5 text-sm text-ink/65 leading-relaxed">
                      {t(`${s.k}.desc`)}
                    </p>
                    <div className="mt-6 flex items-center justify-between">
                      <span className="text-micro uppercase text-ink/50">
                        {s.route === "landing" ? t("services.cta_explore") : t("services.cta_inquire")}
                      </span>
                      <ArrowUpRight className="h-4 w-4 text-ink/40 transition-transform" />
                    </div>
                  </Link>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
